import Reveal from "./Reveal";

export default function SectionHeader({ kicker, title, id }) {
  return (
    <Reveal className="mb-12 sm:mb-16">
      <p className="mb-3 font-mono text-xs uppercase tracking-[0.35em] text-red-500" data-testid={id ? `${id}-kicker` : undefined}>
        {kicker}
      </p>
      <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-zinc-50 sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      <div className="mt-5 h-px w-24 bg-gradient-to-r from-yellow-500 via-red-600 to-transparent" aria-hidden="true" />
    </Reveal>
  );
}
